module.exports = __webpack_public_path__ + "static/media/user-md.041e87be.svg";